import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, usePortal } from '@unite-us/app-components';
import { reject, some } from 'lodash';
import UploadAndAttachDocumentsForm from './UploadAndAttachDocumentsForm';
import '../stylesheets/documentUploader.scss';

function PortalizedUploadAndAttachDocuments({ shouldPortal, children }) {
  return usePortal(children, shouldPortal);
}

class UploadAndAttachDocuments extends Component {
  constructor(props) {
    super(props);
    this.onAttach = this.onAttach.bind(this);
    this.onClose = this.onClose.bind(this);
    this.openDialog = this.openDialog.bind(this);
  }

  onAttach(documents) {
    this.documentDialog.closeModal();
    this.props.onAttachDocuments(documents);
    if (this.props.onModalClose) {
      this.props.onModalClose();
    }
  }

  onClose() {
    this.documentDialog.closeModal('cancel');
    if (this.props.onModalClose) {
      this.props.onModalClose();
    }
  }

  openDialog() {
    this.documentDialog.openModal();
  }

  render() {
    const {
      anchorEl,
      shouldPortal,
      attachedDocuments,
      contactDocuments,
      dropzoneName,
      warningText,
      showDocumentVisibility,
      hasSocialCareNavigationRole,
      modalTitle,
    } = this.props;

    const attachableDocuments = reject(contactDocuments, (document) => (
      some(attachedDocuments, { id: document.id })
    ));

    const modal = (
      <Modal
        id="upload-document-modal"
        title={modalTitle}
        size="large"
        modal
        showBorderRadius
        ref={(el) => { this.documentDialog = el; }}
        onRequestClose={() => this.onClose()}
      >
        <UploadAndAttachDocumentsForm
          documents={attachableDocuments}
          dropzoneName={dropzoneName}
          onAttach={this.onAttach}
          onCancel={this.onClose}
          warningText={warningText}
          showDocumentVisibility={showDocumentVisibility}
          hasSocialCareNavigationRole={hasSocialCareNavigationRole}
        />
      </Modal>
    );

    const modalContent = shouldPortal ?
      <PortalizedUploadAndAttachDocuments shouldPortal={shouldPortal}>{modal}</PortalizedUploadAndAttachDocuments> :
      modal;

    return (
      <div className="upload-and-attach-documents">
        {!shouldPortal && (
          <button
            id="upload-document-link"
            className="upload-and-attach-documents__upload-link"
            type="button"
            onClick={this.openDialog}
          >
            {anchorEl}
          </button>
        )}
        {modalContent}
      </div>
    );
  }
}

UploadAndAttachDocuments.propTypes = {
  anchorEl: PropTypes.node,
  attachedDocuments: PropTypes.array,
  contactDocuments: PropTypes.array,
  dropzoneName: PropTypes.string.isRequired,
  onAttachDocuments: PropTypes.func.isRequired,
  onModalClose: PropTypes.func,
  warningText: PropTypes.string,
  showDocumentVisibility: PropTypes.bool,
  hasSocialCareNavigationRole: PropTypes.bool,
  shouldPortal: PropTypes.bool,
  modalTitle: PropTypes.string,
};

UploadAndAttachDocuments.defaultProps = {
  anchorEl: 'Attach a document',
  attachedDocuments: [],
  contactDocuments: [],
  onModalClose: null,
  showDocumentVisibility: false,
  shouldPortal: false,
  warningText: undefined,
  hasSocialCareNavigationRole: false,
  modalTitle: 'Attach documents',
};

export default UploadAndAttachDocuments;
